import { ChangeDetectionStrategy, Component } from '@angular/core'
import { FormControl } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { sortBy } from 'lodash-es'
import { map, shareReplay, startWith } from 'rxjs/operators'
import { HotkeysService } from '../hotkeys.service'

@Component({
  selector: 'hs-hotkeys-help',
  templateUrl: './hotkeys-help.component.html',
  styleUrls: ['./hotkeys-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HotkeysHelpComponent {
  search = new FormControl('')
  activeHotkeys = this.search.valueChanges.pipe(
    startWith(''),
    map(search => search.toLowerCase()),
    // Case insensitive search of hotkeys
    map(search =>
      Array.from(this.hotkeysService.hotkeys.values()).filter(
        x =>
          (x.description ?? '').toLowerCase().includes(search) ||
          x.name.toLowerCase().includes(search) ||
          x.key.includes(search),
      ),
    ),
    // Sort the hotkeys
    map(hotkeys => sortBy(hotkeys, hotkey => hotkey.name.toLowerCase())),
    shareReplay(1),
  )
  constructor(
    private readonly hotkeysService: HotkeysService<string>,
    readonly activeModal: NgbActiveModal,
  ) {}
}
